import { render } from "./treeItem.vue?vue&type=template&id=97a422be&scoped=true"
import script from "./treeItem.vue?vue&type=script&lang=js"
export * from "./treeItem.vue?vue&type=script&lang=js"

import "./treeItem.vue?vue&type=style&index=0&id=97a422be&lang=scss&scoped=true"
import "./treeItem.vue?vue&type=style&index=1&id=97a422be&lang=css"
script.render = render
script.__scopeId = "data-v-97a422be"

export default script